import { useEffect, useState } from "react";

interface MousePosition {
  x: number;
  y: number;
}

/**
 * Track mouse position for hover-based micro-interactions
 * Desktop only - returns {0, 0} on mobile
 */
export function useMousePosition(): MousePosition {
  const [position, setPosition] = useState<MousePosition>({ x: 0, y: 0 });
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detect mobile
    const checkMobile = () => {
      const mobile = window.innerWidth < 768 || "ontouchstart" in window;
      setIsMobile(mobile);
      return mobile;
    };
    
    const isMobileDevice = checkMobile();

    if (isMobileDevice) {
      const handleResize = () => checkMobile();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }

    const handleMouseMove = (e: MouseEvent) => {
      setPosition({
        x: e.clientX,
        y: e.clientY,
      });
    };

    const handleResize = () => {
      const mobile = checkMobile();
      if (mobile) {
        setPosition({ x: 0, y: 0 });
      }
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile ? { x: 0, y: 0 } : position;
}

